export const HOME_TITLE = "Have a Coupon Code?";
export const HOME_SUBTITLE =
    "Redeem your Swiggy One, One BLCK, or One Lite coupons here to activate your membership now!";
export const APPLY_COUPON_BTN = "Apply Coupon";

export const APP_UPDATE = {
    TITLE: "Please update your app",
    SUB_TITLE: "Don't worry, as soon as you update the app to the latest version, you can try again.",
};

export const INPUT_BOX_PLACEHOLDER = "Enter coupon code";
export const INPUT_BOX_EMPTY_ERROR_MSG = "Invalid coupon code";

export const CHANGE_CITY = "Change City";
